Vue.component('HelpPageIndexComponent', require('./components/HelpPagesIndexComponent').default);
Vue.component('HelpPageGetComponent', require('./components/HelpPagesFormComponent').default);
Vue.component('HelpDialog', require('./components/HelpDialog').default);
